<div class="mb-8 max-w-7xl mx-auto px-4 lg:px-8">
  <!-- Header: Back button on top row -->
  <div class="mb-4">
    <app-btn-back routeTo=".." btnText="BACK"></app-btn-back>
  </div>

  <!-- Title on row below -->
  <div class="mb-4">
    <h1 class="text-2xl font-bold text-primary-500 capitalize">
      AI Credit Transactions
    </h1>
    <p class="text-xs text-gray-500 mt-1">
      History of AI credit consumption and activity logs for this group.
    </p>
  </div>

  <!-- Date Search Filter Card -->
  <div class="border border-blueGray-200/60 rounded-xl p-5 mb-6 flex flex-row gap-2 items-end">
    <div class="flex flex-grow gap-2">
      <div class="grow-6 w-full">
        <label class="block text-xs font-semibold text-gray-500 mb-1">Start Date</label>
        <input type="date" [(ngModel)]="startDate"
          class="w-full h-10 bg-white text-gray-800 border border-gray-300 rounded-lg px-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500">
      </div>
      <div class="grow-6 w-full">
        <label class="block text-xs font-semibold text-gray-500 mb-1">Till Date</label>
        <input type="date" [(ngModel)]="tillDate"
          class="w-full h-10 bg-white text-gray-800 border border-gray-300 rounded-lg px-3 text-sm focus:outline-none focus:ring-2 focus:ring-primary-500">
      </div>
    </div>
    <div class="shrink-0">
      <button (click)="searchTransactions()"
        class="h-10 px-4 lg:px-16 bg-primary-500 hover:bg-primary-600 active:bg-primary-700 text-white text-sm font-semibold rounded-lg transition flex items-center justify-center gap-1.5 shadow-sm whitespace-nowrap">
        <i class="fa fa-search"></i>
        <p class="hidden lg:block text-white">Search</p>
      </button>
    </div>
  </div>

  <!-- Transactions List -->
  <div class="flex flex-col gap-3">
    @if (loading) {
    <div class="py-16 flex flex-col items-center justify-center gap-3 border border-blueGray-200/60 rounded-xl">
      <i class="fa fa-circle-notch fa-spin text-purple-500 text-3xl"></i>
      <p class="text-xs text-gray-400 font-medium">Loading AI transactions...</p>
    </div>
    } @else {
    @for (tx of aiTransactions; track tx.id) {
    <div
      class="p-4 rounded-xl border border-blueGray-200/60 bg-white hover:border-purple-300 transition flex flex-col gap-2 shadow-sm">

      <div class="flex flex-row items-start justify-between">
        <div class="flex flex-col">
          <span class="text-xs text-gray-400">
            {{ (tx.timestamp?.toDate ? tx.timestamp.toDate() : tx.timestamp) | date:'medium' }}
          </span>
          <h4 class="text-sm font-bold text-primary-500 truncate">
            {{ formatFeatureTitle(tx) }}
          </h4>
          <p class="text-xs text-gray-500 truncate" [title]="tx.promptSummary || tx.description">
            {{ tx.promptSummary || tx.description || 'AI generation task' }}
          </p>
        </div>
        <div class="flex flex-col min-w-0">
          <span class="text-base font-black text-purple-600 flex items-center">
            <i class="fa fa-bolt text-xs text-purple-500"></i>
            -{{ (tx.creditsDeducted || (tx.amount < 0 ? -tx.amount : tx.amount) || 0) | number:'1.1-2' }} credits
              </span>
        </div>
      </div>
    </div>
    } @empty {
    <div class="text-center py-16 border border-dashed border-blueGray-200/60 rounded-xl">
      <i class="fa fa-history text-gray-300 text-4xl mb-3"></i>
      <p class="text-sm font-bold text-gray-600">No AI Credit Transactions</p>
      <p class="text-xs text-gray-400 mt-1 max-w-md mx-auto">
        No credit transactions were found for the selected date range. Try expanding your search dates.
      </p>
    </div>
    }
    }
  </div>
</div>